var map = {
	"./american-express.svg": 1460,
	"./apple-pay.svg": 642,
	"./bank.svg": 1431,
	"./blik-logo.svg": 2465,
	"./citadele-bank.png": 9867,
	"./default.svg": 4936,
	"./google-pay-logo-2-dark.svg": 4927,
	"./google-pay-logo-2.svg": 5638,
	"./google-pay-logo.svg": 6899,
	"./google-pay.svg": 7805,
	"./ideal.svg": 7792,
	"./luminor-bank.png": 4616,
	"./mastercard.svg": 269,
	"./medicinos-bank.png": 5680,
	"./revolut-bank.png": 8627,
	"./seb-bank.png": 526,
	"./siauliu-bank.png": 4712,
	"./swedbank-bank.png": 5981,
	"./visa.svg": 4438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1707;